export const unitDisplayNames = {
  per_trip: 'Per Trip',
  per_case: 'Per Case',
  per_box: 'Per Box',
  per_package: 'Per Package',
  per_kg: 'Per Kg',
  per_ton: 'Per Ton',
  per_cft: 'Per CFT',
  per_km: 'Per KM',
  percentage: 'Percentage',
};

export const unitGroups = {
  per_trip: 'per_trip',
  per_case: 'per_case',
  per_box: 'per_box',
  per_package: 'per_package',
  per_kg: 'per_kg',
  per_ton: 'per_kg',
  per_cft: 'per_kg',
  per_km: 'per_km',
  percentage: 'percentage',
};
